<div class="calendar-container" [style.width.px]="containerWidth" (keydown)="keyboard_evt($event)">
  <div class="calendar-header"
       (wheel)="onHeaderWheel($event)">
    <div *ngIf="columnHeaderName[0]" class="time-header-cell">
      {{columnHeaderName[0].substring(0,7)}}
    </div>

    <div *ngFor="let colHeader of supColumnHeaders"
         [title]="colHeader+'\n\nCliquer pour retirer la colonne'"
         class="header-cell"
         (click)="fire_entete.emit(colHeader)">
      {{convert_to_find_day(colHeader)}}
    </div>
  </div>

  <div class="calendar-header" *ngIf="columnHeaderName[1] && columnHeaderName[1].length>0">
    <div class="time-header-cell">
        <mat-icon style="opacity: 0.3;margin-bottom:-10px;margin-left:0px;font-size: medium"
                  (click)="zoom_entete(10)">zoom_in</mat-icon>
        /&nbsp;
        <mat-icon style="opacity: 0.3;margin-bottom:-10px;font-size: medium"
                  (click)="zoom_entete(-10)">zoom_out</mat-icon>
    </div>
    <div *ngFor="let colHeader of columnHeaders"  class="sub-header-cell">
      {{ colHeader.indexOf("-")>-1 ? shorter(convert_to_find_day(colHeader.split("-")[1])) : shorter(convert_to_find_day(colHeader)) }}
    </div>
  </div>


  <div class="calendar-body" (pinch)="onPinch($event)">
    <!-- Colonne des heures -->
    <div class="time-column" (wheel)="onWheel($event)" id="time_col"
         title="Vous pouvez zoomer / dézoomer l'échelle de temps avec la molette">
      <div *ngFor="let time of timeSlots"
           class="time-slot-label" [style.height.px]="rowHeightPx">
        {{ time }}
      </div>
    </div>


    <div *ngFor="let colHeader of columnHeaders" class="event-column">
      <div class="events-container" [style.height.px]="totalSlots * rowHeightPx" >
        <div *ngFor="let event of getEventsForColumn(colHeader,columnHeaderName,events)"
             class="calendar-event"
             [ngStyle]="calculateEventStyle(event)"
             (dblclick)="open_event(event)"
             [title]="get_infos(event,eventDisplayInfoBulle,'text')"
             (contextmenu)="onContextMenu($event, event)"
             [style]="event.style">
          <div [innerHTML]="get_infos(event,eventDisplayMask,'html')"></div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Context Menu -->
<div class="context-menu"
     *ngIf="contextMenuVisible"
     [style.left.px]="contextMenuX"
     [style.top.px]="contextMenuY"
     (click)="$event.stopPropagation()">
  <div *ngFor="let menu of context_menu_enabled" class="context-menu-item" (click)="onContextMenuAction(menu.toLowerCase())">{{menu}}</div>
  <div class="context-menu-item" (click)="onContextMenuAction('fermer')">Fermer</div>
</div>
